import axios from 'axios'
import notification from 'ant-design-vue/es/notification'
import { getOssConfig } from '@/api/system/upload.js'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { guid } from '@/utils/ruoyi.js'

export default class UploadFileToOSS {

    /**
     * [constructor description]
     * @param  {[Array]} files [chooseImg选中的tempFilePaths、chooseVideo选中的rempFilePath]
     * @param  {[Object]} json  [success每上传成功一张调用 complete全部上传完成调用]
     * @return {[void]}       [description]
     */

    constructor(files, json) {
        if (!Array.isArray(files)) {
            throw new Error('Class UploadFileToOSS parameter must be an array');
        }
        console.log('files, json', files, json)
        this.data = [];
        this.fn = json.success;
        this.complete = json.finally;
        this.files = files;
        this.fileLen = this.files.length;
        this.curIndex = 0;
        // notification.info({ message: '上传中' })
      
        this.upload();
    }

    async upload() {
        const token = storage.get(ACCESS_TOKEN)
        // 随机生成一个文件名，并且按照日期归类到二级目录下，否则很容易产生覆盖
        const dates = new Date()
        const year = dates.getFullYear()
        const month = dates.getMonth() + 1
        const date = dates.getDate()
        const nowDate = year + '-' + (month < 10 ? `0${month}` : month) + '-' + (date < 10 ? `0${date}` : date)
        const bmonth = month < 10 ? `0${month}` : month
        const bdate = date < 10 ? `0${date}` : date
        getOssConfig().then(res => {
            let ossData = res.data
            let form = new FormData()
            console.log('文件',this.files)
            let name = this.files[0].type.split("/")[1]
            let lastIndex = this.files[0].name.lastIndexOf('.');
            if (lastIndex !== -1) {
               name = this.files[0].name.slice(lastIndex + 1);
            }
          let oriName = this.files[0].name;
            form.append('key', `${year}/${bmonth}/${bdate}/` + ossData.fileName + '.' + name)
            form.append('policy', ossData.policy)
            form.append('OSSAccessKeyId', ossData.accessid)
            form.append('success_action_status', '200')
            form.append('signature', ossData.signature)
            form.append('file', this.files[0])
            
            // OSS直传不需要自定义headers，让浏览器自动处理FormData
            // 移除Authorization和Content-Disposition，这些会导致CORS问题
            axios({
                url: ossData.uploadUrl,
                method: 'post',
                // OSS直传时，不要设置Content-Type，让浏览器自动设置（包含boundary）
                // 也不要设置Authorization，OSS直传使用policy和signature验证
                data: form,
                onUploadProgress: (ev) => {
                    // ev - axios 上传进度实例，上传过程触发多次
                    // ev.loaded 当前已上传内容的大小，ev.total - 本次上传请求内容总大小
                    const percent = (ev.loaded / ev.total) * 100
                    // console.log(ev,percent,"进度")
                    // 计算出上传进度，调用组件进度条方法
                    // files.onProgress({ percent })
                },
            }).then(res => {
                console.log('OSS上传响应:', res)
                // OSS直传成功时，status可能是200或204
                if (res.status === 200 || res.status === 204) {
                    let url = ossData.resultUrl + `/${year}/${bmonth}/${bdate}/` + ossData.fileName + '.' + name
                    this.data.push({
                        uid: guid(8, 10),
                        status: 'done',
                        name: oriName,
                        halfUrl: `${year}/${bmonth}/${bdate}/` + ossData.fileName + '.' + name,
                        path: url,
                        url: url,
                        cover: ''
                    });
                    if (this.fn) this.fn(this.data);
                } else {
                    console.error('上传失败，状态码:', res.status)
                    notification.error('上传失败，请重试')
                }
            }).catch(err => {
                console.error('OSS上传错误:', err)
                console.error('错误详情:', {
                    message: err.message,
                    response: err.response,
                    request: err.request
                })
                
                let errorMsg = '上传失败，请重试'
                if (err.response) {
                    // 服务器返回了错误响应
                    if (err.response.status === 403) {
                        errorMsg = '上传失败：权限不足或签名已过期'
                    } else if (err.response.status === 400) {
                        errorMsg = '上传失败：请求参数错误'
                    } else if (err.response.data && err.response.data.message) {
                        errorMsg = '上传失败：' + err.response.data.message
                    }
                } else if (err.request) {
                    // 请求已发出但没有收到响应（网络错误或CORS问题）
                    errorMsg = '上传失败：网络错误或跨域问题，请检查OSS配置'
                } else if (err.message) {
                    errorMsg = '上传失败：' + err.message
                }
                
                notification.error(errorMsg)
            }).finally(() => {
                if (this.fn) this.fn(this.data);
                this.curIndex++; // 当前文件执行完上传后，开始上传下一张
                if (this.curIndex == this.fileLen) { // 当文件传完时，停止调用
                    if (this.complete) this.complete(this.data);
                } else { // 若文件还没有传完，则继续调用函数
                    this.upload();
                }
            })
        })
    }
}